import { MessageType } from "@bvhi/backend-api";
import { Chip, ChipProps } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface Props extends ChipProps {
  type: MessageType;
}

export function MessageTypeCell({ type, size = "small", ...chipProps }: Props) {
  const { t } = useTranslation(["enums"]);

  const label = useMemo(() => {
    switch (type) {
      case MessageType.DESPATCH_ADVICE:
        return t("enums:enums.message.type.despatch.advice");
      case MessageType.INVOICE:
        return t("enums:enums.message.type.invoice");
      case MessageType.ORDER:
        return t("enums:enums.message.type.order");
      case MessageType.OTHER:
        return t("enums:enums.message.type.other");
      case MessageType.TEST:
        return t("enums:enums.message.type.test");
      case MessageType.TRANSPORT_ACKNOWLEDGEMENT:
        return t("enums:enums.message.type.transport.acknowledgement");
    }
    return "";
  }, [type, t]);

  return <Chip label={label} size={size} {...chipProps} />;
}
